<!-- 地图 -->
<template>
  <div class="centerMapContent">
    <div v-loading="loading" id="centermap" class="homepage-map"></div>
    <div class="list">
      <div class="title" style="font-size:16px;">沿河村落预警信息(<span>{{this.warningNum}}</span>)</div>
      <div class="btn" v-if="btn">
        <el-button size="mini" type="primary" @click="changeWarnStatusInfo('启动内部预警',multipleSelection)">批量启动</el-button>
        <el-button size="mini" type="danger" @click="changeWarnStatusInfo('关闭预警',multipleSelection)">批量忽略</el-button>
      </div>
      <div class="btn" v-if="!btn">
        <el-button size="mini" type="primary" @click="showPerson(currentRow)">短信预警</el-button>
        <el-button size="mini" type="danger" @click="changeWarnStatusInfo('关闭预警',[currentRow])">结束预警</el-button>
      </div>
      <div class="botton_content">
        <el-tabs v-model="activeTabs" @tab-click="tabClick">
          <el-tab-pane label="新产生预警" name="tabFirst">
            <div class="listtable">
              <el-table
                ref="multipleTable1"
                v-loading="loading2"
                :data="newEarlyWarnData"
                :height="tableheight"
                tooltip-effect="dark"
                style="width:100%"
                @row-click="clickRow1" border
                @selection-change="handleSelectionChange">
                <el-table-column
                  type="selection"
                  min-width="30">
                </el-table-column>
                <el-table-column
                  prop="adnm"
                  label="预警地区"
                  min-width="90">
                </el-table-column>
                <el-table-column
                  prop="warnTM"
                  label="预警产生时间"
                  min-width="120">
                </el-table-column>
                <el-table-column
                  prop="warnStatusNM"
                  label="预警状态"
                  min-width="70"
                  show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="预警列表" name="tabSecond">
            <div class="listtable">
              <el-table
                ref="multipleTable2"
                v-loading="loading2"
                :data="warnListData"
                :height="tableheight"
                tooltip-effect="dark"
                style="width:100%"
                highlight-current-row
                @current-change="handleCurrentChange"
                border>
                <el-table-column
                  prop="adnm"
                  label="预警地区"
                  min-width="70">
                </el-table-column>
                <el-table-column
                  prop="warnTM"
                  label="预警产生时间"
                  min-width="100"
                  show-overflow-tooltip
                  sortable>
                </el-table-column>
                <el-table-column
                  prop="warnStatusNM"
                  label="预警状态"
                  min-width="70"
                  show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog class="abow_dialog" title="发送短信" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <div class="personList">
        <el-table :data="smsPersonList" border style="width: 100%" :height="500" empty-text="暂无配置人员可发送预警短信">
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column prop="personName" label="姓名" width="" align="center">
          </el-table-column>
          <el-table-column prop="adcdName" label="部门/行政区划" width="" align="center">
          </el-table-column>
          <el-table-column prop="personPosition" label="岗位/职务" width="" align="center">
          </el-table-column>
          <el-table-column prop="personPhone" label="手机" width="" align="center">
          </el-table-column>
          <el-table-column label="操作" width="" align="center">
            <template slot-scope="scope">
              <el-button @click.native.prevent="deleteRow(scope.$index)" type="text" size="small">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="personAdd">
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入需要添加的手机号,每个手机号必须用逗号隔开"
          v-model="otherPhone"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="showSms">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="发送短信"
      :visible.sync="smsVisible"
      :close-on-click-modal="false"
      v-loading="loading3"
      element-loading-text="发送短信中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <fieldset>
        <legend class="legend">短信内容</legend>
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入短信内容"
          v-model="message"
        ></el-input>
      </fieldset>
      <span slot="footer" class="dialog-footer">
        <el-button @click="smsVisible = false">关 闭</el-button>
        <el-button type="primary" @click="send">发 送</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as L from 'leaflet'
import warnTypes from '@/store/types/warningcenter'
// import config from '@/config'
import request from '@/utils/request'
require('@/extend/leaflet-extend.js')
require('@/assets/map/leaflet.ChineseTmsProviders.js')
export default {
  name: 'centermap',
  components: {},
  data () {
    return {
      tableheight: document.documentElement.clientHeight - (document.documentElement.clientHeight * 0.35),
      // tableheight1: document.documentElement.clientHeight - (document.documentElement.clientHeight * 0.6),
      btn: true,
      activeTabs: 'tabFirst',
      warningNum: '',
      loading: true,
      loading2: true,
      loading3: false,
      newEarlyWarnData: [],
      warnListData: [],
      multipleSelection: [],
      currentRow: {},
      form: { },
      warnNM: '',
      map: {},
      warnIDs: '',
      message: '',
      smsVisible: false,
      dialogVisible: false,
      smsPersonList: [],
      otherPhone: '',
      phoneList: []
    }
  },
  // 监听属性 类似于data概念
  computed: {
    mapSize () {
      let styleObj = {
        width: this.mapWidth,
        height: this.mapHeight
      }
      return styleObj
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // tabs切换
    tabClick (tab, event) {
      if (this.activeTabs === 'tabFirst') {
        this.btn = true
      } else {
        this.btn = false
      }
    },
    deleteRow (index) {
      this.smsPersonList.splice(index, 1)
    },
    showPerson (item) {
      if (!item || JSON.stringify(item) === '{}') {
        this.$notify({ title: '提示', message: '请选择预警信息' })
        return
      }
      this.loading = true
      this.$store.dispatch(warnTypes.person_order_warnid, { warnID: item.warnID }).then(data => {
        this.loading = false
        this.smsPersonList = data.rows
        this.message = this.currentRow.warnDesc
        this.dialogVisible = true
      })
    },
    showSms () {
      let phoneList = []
      if (this.otherPhone) {
        phoneList = this.otherPhone.replace(/，/g, ',').split(',')
      }
      this.smsPersonList.forEach(item => {
        phoneList.push(item.personPhone)
      })
      this.phoneList = [...new Set(phoneList)]
      if (this.phoneList.length > 0) {
        this.smsVisible = true
      } else {
        this.$notify({ title: '提示', message: '请至少添加一条手机号码' })
      }
    },
    send () {
      let sendPersonList = []
      this.phoneList.forEach(item => {
        sendPersonList.push({
          PersonPhone: item
        })
      })
      this.loading3 = true
      this.$store.dispatch(warnTypes.SENG_MESSAGE, {
        sendPersonList: sendPersonList,
        sendTxt: this.message
      }).then(data => {
        this.loading3 = false
        if (data.isSuccess) {
          this.dialogVisible = false
          this.smsVisible = false
          this.$notify({ title: '提示', message: '发送成功' })
        } else {
          this.$notify({ title: '提示', message: data.errorMsg })
        }
      })
    },
    // 新产生预警信息
    getNewEarlyWarning () {
      this.loading2 = true
      this.$store.dispatch(warnTypes.GET_EARLY_WARNING_LIST, { yjtype: 0, pageIndex: 1, pageSize: 999 }).then(data => {
        this.newEarlyWarnData = data.results
        this.drawPoint(data.results)
        this.loading2 = false
      })
    },
    // 预警信息列表
    getEarlyWarningList () {
      this.loading2 = true
      this.$store.dispatch(warnTypes.GET_EARLY_WARNING_LIST, { yjtype: '10,20', isscreen: true, pageIndex: 1, pageSize: 999 }).then(data => {
        this.warnListData = data.results
        this.warningNum = this.warnListData.length
        this.drawPoint(data.results)
        this.loading2 = false
      })
    },
    // 改变预警状态信息
    changeWarnStatusInfo (status, list) {
      const warnArr = []
      list.forEach((item) => {
        warnArr.push(item.warnID)
      })
      this.warnIDs = warnArr.join(',')
      if (!this.warnIDs) {
        this.$notify({ title: '提示', message: '请选择预警信息' })
        return
      }
      this.$confirm(`确定${status}吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading2 = true
        this.$store.dispatch(warnTypes.CHANGE_WARNING_STATUS, { WarnIds: this.warnIDs, WarnStatus: status }).then(data => {
          if (data.isSuccess) {
            this.getNewEarlyWarning()
            this.getEarlyWarningList()
            this.$notify({ title: '提示', message: '操作成功!' })
            this.warnIDs = ''
            this.multipleSelection = []
            this.currentRow = {}
            this.loading2 = false
          }
        })
      })
    },
    //  行选中
    clickRow1 (row) {
      this.$refs.multipleTable1.toggleRowSelection(row)
      this.map.flyTo([row.lttd, row.lgtd], 18, {
        animate: true,
        duration: 1
      })
    },
    //  行选中
    clickRow2 (row) {
      this.map.flyTo([row.lttd, row.lgtd], 18, {
        animate: true,
        duration: 1
      })
    },
    handleCurrentChange (item) {
      this.currentRow = JSON.parse(JSON.stringify(item))
    },
    handleSelectionChange (val) {
      this.multipleSelection = JSON.parse(JSON.stringify(val))
    },
    leaflet () {
      let map = ''
      map = L.CreateTianDiTuMap('centermap', {
        mapType: 3,
        minZoom: 10, // 最小缩放等级
        maxZoom: 18,
        crs: L.CRS.EPSG4490,
        zoomControl: false }).setView([28.34, 120.77], 11)
      // L.tileLayer.CustomArcGISServerLayer(
      //   config.ApiLA + '/assets/images/town/' // 地图服务地址
      // ).addTo(map)

      var myStyle = {
        'color': '#2dd9f8',
        'weight': 1,
        'opacity': 1
      }
      request.get('https://' + window.location.host + '/yjjson/yongjiaTown.json').then(res => {
        L.geoJSON(res.data, {
          style: myStyle
        }).addTo(map)
      })
      this.map = map
      this.loading = false
    },
    // 地图上添加标记点
    drawPoint (allData) {
      // 添加点
      var map = this.map
      var myIcon
      allData.forEach(item => {
        if (item.warnGradeNM === '准备转移') {
          myIcon = L.icon({
            iconUrl: require('@/assets/warnCenter_img/animate.gif'),
            iconAnchor: [8, 8]
          })
        } else if (item.warnGradeNM === '实施转移') {
          myIcon = L.icon({
            iconUrl: require('@/assets/warnCenter_img/animate1.gif'),
            iconAnchor: [8, 8]
          })
        }
        var markers = L.marker([item.lttd, item.lgtd], { icon: myIcon, title: item.adcdName }).addTo(map)
        markers.bindPopup(
          '<div class="villaegName">' + item.adnm + '</div>' +
          '<div id="tab">' +
            '<ul class="list">' +
            '</ul>' +
            '<ul class="tab">' +
              '<li class="tab_nav on">' +
                '<div class="tabcontnet">' +
                  '<div class="contentname"><span>乡镇:</span></div>' +
                  '<div class="contentnum"><span>' + item.adnm + '</span></div>' +
                '</div>' +
                '<div class="tabcontnet">' +
                  '<div class="contentname"><span>预警名称:</span></div>' +
                  '<div class="contentnum"><span>' + (item.warnNM === undefined ? '-' : item.warnNM) + '</span></div>' +
                '</div>' +
                '<div class="tabcontnet">' +
                  '<div class="contentname"><span>预警类型:</span></div>' +
                  '<div class="contentnum"><span>' + (item.warnTypeNM === undefined ? '-' : item.warnTypeNM) + '</span></div>' +
                '</div>' +
                '<div class="tabcontnet">' +
                  '<div class="contentname"><span>预警等级:</span></div>' +
                  '<div class="contentnum"><span>' + (item.warnGradeNM === undefined ? '-' : item.warnGradeNM) + '</span></div>' +
                '</div>' +
                '<div class="tabcontnet">' +
                  '<div class="contentname"><span>预警状态:</span></div>' +
                  '<div class="contentnum"><span>' + (item.warnStatusNM === undefined ? '-' : item.warnStatusNM) + '</span></div>' +
                '</div>' +
                // '<div class="tabcontnet">' +
                //   '<div class="contentname"><span>预警描述:</span></div>' +
                //   '<div class="contentnum"><span>' + (item.warnDesc === undefined ? '-' : item.warnDesc) + '</span></div>' +
                // '</div>' +
                '<div class="tabcontnet">' +
                  '<div class="contentname"><span>开始时间:</span></div>' +
                  '<div class="contentnum"><span>' + (item.warnSTM === undefined ? '-' : item.warnSTM) + '</span></div>' +
                '</div>' +
                '<div class="tabcontnet">' +
                  '<div class="contentname"><span>结束时间:</span></div>' +
                  '<div class="contentnum"><span>' + (item.warnETM === undefined ? '-' : item.warnETM) + '</span></div>' +
                '</div>' +
                '<div class="tabcontnet">' +
                  '<div class="contentname"><span>是否上报:</span></div>' +
                  '<div class="contentnum"><span>' + (item.isSb === undefined ? '-' : (item.isSb ? '已上报' : '未上报')) + '</span></div>' +
                '</div>' +
              '</li>' +
            '</ul>' +
          '</div>'
        )
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.leaflet()
    this.getNewEarlyWarning()
    this.getEarlyWarningList()
  }
}
</script>
<style lang="less" src="@/assets/warningcenter.less" scoped></style>
<style scoped>
@import url('../../../assets/map/leaflet.css');
  .centerMapContent >>>.search1 {
    width: 120px;
    float: left;
 }
  .centerMapContent >>>.search2 {
    width: 120px;
    float: left;
 }
 .centerMapContent >>>.search .xzc {
    width: 210px;
    float: left;
 }
  .centerMapContent >>>.search .cun {
    width: 180px;
    float: left;
    /* margin-left: 5px; */
 }
 .el-table{
   font-size: 12px !important;
 }
 .el-input__inner {
    height: 30px !important;
    line-height: 24px !important;
    padding: 0px 14px !important;
}
 .el-input__prefix, .el-input__suffix {
    top: 3px !important;
}
 .search{
   float: left;
   font-size: 16px;
 }
 .centerMapContent{
   width:100%;
   height: 100%;
 }
 #centermap{
    width:100%;
    height: 100%;
    position: relative;
  }
  .mapboxgl-control-container{
    display: none;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-row:last-child {
      margin-bottom: 0;
    }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background:rgba(162,44,25,.6);
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .centerMapContent >>> .el-tabs{
    margin-top: -30px;
  }
  .centerMapContent >>> .el-table tr:nth-child(even) {
    background: #eaf1fa;
  }
  .centerMapContent >>> .el-table thead {
    color: #909399;
    font-weight: 500;
    background: #F5F7FA;
  }
  .centerMapContent >>> .el-table th {
    /* color: #08A2F3; */
    text-align: center;
    background: #F5F7FA;
  }
.centerMapContent >>> .el-table td, .el-table th.is-leaf{
  border: none;
}
.centerMapContent >>> .el-table th.is-leaf {
  border: none;
}
.centerMapContent >>> .tabcontnet {
  width: 50%;
  margin-top: 10px;
  float: left
}
.centerMapContent >>> .contentname {
  margin-left: 2%;
  width: 100px;
  float: left;
  color: #999999;
}
.centerMapContent >>>.contentnum {
  width: 150px;
  float: left;
  color: rgb(238, 121, 12);
}
.centerMapContent >>> .el-table .cell{
  text-align: center !important;
}
.centerMapContent >>>.abow_dialog2 .el-dialog{
  width: 600px;
}
.centerMapContent >>> .el-dialog__body {
  height: 70%;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
.btn{
  /* float: right; */
  right: 30px;
  margin-top: 20px;
  position: absolute;
  z-index: 999999;
}
.el-button--mini, .el-button--mini.is-round {
    padding: 8px 10px !important;
}
.centerMapContent >>> .el-form-item{
  margin-left: 1%;
  width: 80% !important;
}
</style>
<style>
  /* 首页地图样式覆盖 */
  /* 地图按钮 */
  .homepage-map .leaflet-top{
    top: 80px;
  }
  .homepage-map .leaflet-bottom{
    display: none;
  }
</style>
<style lang="less" scoped>
.centerMapContent #centermap /deep/ .leaflet-popup-pane .leaflet-zoom-animated{
  width:600px;
  height:240px;
  .leaflet-popup-content{
    width: 555px !important;
    .villaegName {
      font-size: 18px;
      color: #303133;
    }
    #tab{
      position: relative;
      width: 100%;
      height: 185px;
      margin: 10px auto;
      .list {
        width: 100%;
        height: 25px;
        padding: 0;
        margin: 2px auto;
        border-bottom: 1px solid #ccc;
      }
      li {
        list-style: none;
      }
      .list_nav {
        float: left;
        width: 90px;
        height: 25px;
        font-size: 15px;
        text-align: center;
        line-height: 25px;
        cursor: pointer;
      }
      .active {
        color: #409EFF;
        border-bottom: 1px solid #409EFF;
      }
      .tab_nav {
        display: none;
        position: absolute;
        top:25px;
        width: 100%;
      }
      .on {
        display: block;
      }
      .tab {
        width:100%;
        height:80%;
        padding: 0;
        margin: 0 auto;
        .tabcontnet {
          font-size: 15px;
        }
      }
    }
  }
}
.centerMapContent /deep/ #centermap .leaflet-control-container .leaflet-top {
  z-index: 996;
}
.list{
  width: 420px;
  height: 820px;
  background: #ffffff;
  position: absolute;
  top: 110px;
  right: 20px;
  z-index: 997;
  .search_content{
    width: 100%;
    float: left;
    .search{
      margin-top: 15px;
      color: #666666;
    }
  }
  .botton_content{
    width: 100%;
    height: 90%;
    float: left;
    text-align: right;
    padding: 0 15px;
    .jzyj{
      margin-top: 15px;
      margin-left: 12px;
    }
    .el-tabs {
      height: 97%;
      margin-top: 20px;
      .listtable{
        width: 100%;
        float: left;
      }
      #pane-tabSecond {
        height: 100%;
        .list_down{
          width: 390px;
          height: 350px;
          float: left;
          .process{
            width: 100%;
            height: 90%;
            background: url('../../../assets/warnCenter_img/warningList_down.png') no-repeat;
            background-position: center center;
          }
        }
      }
    }
  }
  .title{
    color: #666666;
    font-size: 20px;
    margin-top: 10px;
    margin-left: 10px;
    span{
      font-size: 14px;
      color: #FF3366;
    }
  }
}

/* 新建/编辑 */
.personAdd{
  margin-top: 10px;
}
.legend {
  width: auto;
  margin-bottom: 0;
  padding: 0 10px;
  border: none;
  color: #6a9bf3;
  font: 500 18px 'Microsoft YaHei UI';
}
@media screen and (max-width:1900px){
  .list{
    width: 490px;
  }
}
</style>
